<template>
    <div class="inc_right">
        <div class="faqall">
            <!--整體列表-->
            <div :class="table_Class">
                <!--內容列表查無資料物件-->
                <div :class="list_Class" v-if="list.length==0">
                    <div class="hmnewword">
                        {{ NotData }}
                    </div>
                </div>
                <!--內容列表物件-->
                <div v-else
                    :class="list_Class" v-for="(item , index) in list" :key="index">
                    <div class="qus">
                        <!--div class="qunum">
                            {{ "Q"+item.qnum }}
                        </div-->
                        <div class="quwwd">
                            {{item.title}}
                        </div>
                        <div class="faqaw">
                            <!-- TODO 點選時調整按鈕-->
                            <img src="/images/faq_aw.png" />
                        </div>
                    </div>
                    <!--答內容-->
                    <div class="ans" v-html="item.ans"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            //列表樣式
            table_Class:"",
            //文章項目樣式
            list_Class:"",
            //無資料時預設文字
            NotData:"",
            //列表資料
            list:[{
                qnum:1,
                title:"",
                ans:"",
            }],
        };
    },
    props:["sideright"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "sideright.list"(){
            //初始化
            this.init();
        },
    },
    methods:{
        init(){
            //2025-11-14 讀取FAQ下拉功能
            const script = document.createElement("script");
            script.setAttribute('nonce', 'SHhzTzNmaWIxZjZJWmVsRg==');
            script.src = "/js/faq.js";
            document.body.appendChild(script);
            this.table_Class = this.sideright.table_Class;
            this.list_Class = this.sideright.list_Class;
            this.list = this.sideright.list;

            
            if( this.sideright && this.sideright.list.length ==1 ){
                if(this.sideright.list[0].qnum == 0){
                    this.list = [];
                    this.NotData = "Not Data";
                }
            }
        }
    }

}
</script>